import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {AuthOPEEnum} from "./AuthOPEEnum";

class O {
}

/**
 * O Inner Class
 */
class I {
  username!: string;
  newHashedPassword!: string;
}


/**
 * GetWidgetsCB class
 */
export class SaveNewPasswordCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(AuthOPEEnum.SaveNewPassword);
    this.i = new I();
    this.o = new O();
  }

}
